/*
// 页面
import HomeBox from './../pages/HomeBox'

//新页面
import home from './../pages/home'
import login from './../pages/login'

//返回路由
import ask_price from '../pages/askPrice/ask_price'
import ask_price_details from '../pages/askPrice/ask_price_details'
import calculator from '../pages/askPrice/calculator'
import mine from '../pages/mine'*/


//懒加载路由
const HomeBox = r => require.ensure([], () => r(require('./../pages/HomeBox')), 'HomeBox')
const home = r => require.ensure([], () => r(require('./../pages/home.vue')), 'home')

const login = r => require.ensure([], () => r(require('./../pages/login.vue')), 'login')

//问问价
const ask_price = r => require.ensure([], () => r(require('../pages/askPrice/ask_price')), 'ask_price')
const ask_price_details = r => require.ensure([], () => r(require('../pages/askPrice/ask_price_details')), 'ask_price_details')
//计算器
const calculator = r => require.ensure([], () => r(require('../pages/askPrice/calculator')), 'calculator')
//我的
const mine = r => require.ensure([], () => r(require('../pages/mine')), 'mine')
//商品管理
const commodity_manage = r => require.ensure([], () => r(require('../pages/commodity/commodity_manage')), 'commodity_manage')
const commodity_detail = r => require.ensure([], () => r(require('../pages/commodity/commodity_detail')), 'commodity_detail')
const commodity_edit = r => require.ensure([], () => r(require('../pages/commodity/commodity_edit')), 'commodity_edit')
const commodity_theIndexImage = r => require.ensure([], () => r(require('../pages/commodity/commodity_theIndexImage')), 'commodity_theIndexImage')
const commodity_search = r => require.ensure([], () => r(require('../pages/commodity/commodity_search')), 'commodity_search')
const commodity_searchList = r => require.ensure([], () => r(require('../pages/commodity/commodity_searchList')), 'commodity_searchList')
const commodity_download = r => require.ensure([], () => r(require('../pages/commodity/commodity_download')), 'commodity_download')
//悬赏找花
const reward_manage = r => require.ensure([], () => r(require('../pages/reward/reward_manage')), 'reward_manage')
const reward_reject = r => require.ensure([], () => r(require('../pages/reward/reward_reject')), 'reward_reject')
const reward_detail = r => require.ensure([], () => r(require('../pages/reward/reward_detail')), 'reward_detail')
//商机管理
const orderInquiry_manage = r => require.ensure([], () => r(require('../pages/orderInquiry/orderInquiry_manage')), 'orderInquiry_manage')
const orderInquiry_detail = r => require.ensure([], () => r(require('../pages/orderInquiry/orderInquiry_detail')), 'orderInquiry_detail')
const orderInquiry_reply = r => require.ensure([], () => r(require('../pages/orderInquiry/orderInquiry_reply')), 'orderInquiry_reply')
const orderInquiry_msgList = r => require.ensure([], () => r(require('../pages/orderInquiry/orderInquiry_msgList')), 'orderInquiry_msgList')






const test = r => require.ensure([], () => r(require('../pages/test')), 'test')
const calculator2 = r => require.ensure([], () => r(require('../pages/askPrice/calculator2')), 'calculator2')


let routes = [
  {
    path: '/',
    component: HomeBox,
    name: 'HomeBox',
    children: [
        {
            path: '/login',
            component: login,
            meta: {
                title: '登录'
            }
        },
        {
            path: '/home',
            name: 'home',
            component: home,
            meta: {
                title: '辅布司BOSS'
            }
        },
        {
            path: '/mine',
            name: 'mine',
            component: mine,
            meta: {
                title: '个人中心'
            }
        },
        /**
         * 问问价
         */
        {
            path: '/ask_price',
            name: 'ask_price',
            component: ask_price,
            meta: {
                title: '问问价'
            }
        },
        {
            path: '/ask_price_details',
            name: 'ask_price_details',
            component: ask_price_details,
            meta: {
                title: '问价详情'
            }
        },
        /**
         * 计算器
         */
        {
            path: '/calculator',
            name: 'calculator',
            component: calculator,
            meta: {
                title: '报价计算器'
            }
        },
        /**
         * 商品
         */
        {
            path: '/commodity_manage',
            name: 'commodity_manage',
            component: commodity_manage,
            meta: {
                title: '商品管理'
            }
        },
        {
            path: '/commodity_detail',
            name: 'commodity_detail',
            component: commodity_detail,
            meta: {
                title: '商品详情'
            }
        },
        {
            path: '/commodity_edit',
            name: 'commodity_edit',
            component: commodity_edit,
            meta: {
                title: '商品编辑'
            }
        },
        {
            path: '/commodity_theIndexImage',
            name: 'commodity_theIndexImage',
            component: commodity_theIndexImage,
            meta: {
                title: '商品索引图'
            }
        },
        {
            path: '/commodity_search',
            name: 'commodity_search',
            component: commodity_search,
            meta: {
                title: '商品搜索'
            }
        },
        {
            path: '/commodity_searchList',
            name: 'commodity_searchList',
            component: commodity_searchList,
            meta: {
                title: '商品结果'
            }
        },
        {
            path: '/commodity_download',
            name: 'commodity_download',
            component: commodity_download,
            meta: {
                title: '商品下载'
            }
        },
        /**
         * 悬赏找花
         */
        {
            path: '/reward_manage',
            name: 'reward_manage',
            component: reward_manage,
            meta: {
                title: '悬赏找花管理',
                keepAlive: true
            }
        },
        {
            path: '/reward_reject',
            name: 'reward_reject',
            component: reward_reject,
            meta: {
                title: '驳回理由'
            }
        },
        {
            path: '/reward_detail',
            name: 'reward_detail',
            component: reward_detail,
            meta: {
                title: '悬赏找花详情'
            }
        },
        /**
         * 商机管理
         */
        {
            path: '/orderInquiry_manage',
            name: 'orderInquiry_manage',
            component: orderInquiry_manage,
            meta: {
                title: '商机管理'
            }
        },
        {
            path: '/orderInquiry_detail',
            name: 'orderInquiry_detail',
            component: orderInquiry_detail,
            meta: {
                title: '商机详情'
            }
        },
        {
            path: '/orderInquiry_reply',
            name: 'orderInquiry_reply',
            component: orderInquiry_reply,
            meta: {
                title: '商机回复'
            }
        },
        {
            path: '/orderInquiry_msgList',
            name: 'orderInquiry_msgList',
            component: orderInquiry_msgList,
            meta: {
                title: '商机消息'
            }
        },










        {
            path: '/',
            component: home
        },



        {
            path: '/test',
            component: test
        },
        {
            path: '/calculator2',
            component: calculator2
        },
    ]
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js